import { Modal } from 'antd';
import React from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import TranslateText from 'components/hoc/TranslateText';

interface IErrModal {
    setModalMsg: React.Dispatch<React.SetStateAction<string | undefined>>;
    modalMsg?: string;
}

const ErrModal: React.FC<IErrModal> = props => {
    const { modalMsg, setModalMsg } = props;

    return (
        <Modal
            title={<TranslateText>{modalMsg || ''}</TranslateText>}
            open={!!modalMsg}
            afterClose={() => {
                setModalMsg(undefined);
            }}
            footer={null}
        >
            <ButtonComponent
                id="seznamPozadavkuZpetAltBtn"
                style={{
                    marginTop: 20
                }}
                buttontext="ZAVRIT"
                type="default"
                onClick={() => {
                    setModalMsg(undefined);
                }}
            />
        </Modal>
    );
};

export default ErrModal;
